export default {"src":"/_next/static/media/orchestration_en.2af2dc8b.svg","height":1440,"width":2004};